module.exports = "<div class=\"cierant-checkbox\" (click)=\"onCheckChange()\" [class.checked]=\"checked\">\r\n    <span class=\"fa fa-check\"></span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/cierant-checkbox/cierant-checkbox.component.html
// module id = ./src/app/shared/components/cierant-checkbox/cierant-checkbox.component.html
// module chunks = main